export enum site {
    IX = 1,
    GA = 2,
    ALL = 1000,
}
export const siteNames = {
    [site.IX]: 'IX',
    [site.GA]: 'GA',
    [site.ALL]: 'All',
};
